import { Component, Input, OnInit } from '@angular/core';
import { Shipment } from '../../../models/shipment';
import { ShipmentService } from '../../../data/shipment.service';
import { filter, map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ShipmentStatusEnum } from '../../../enum/shipment-status.enum';
import { DimensionPipe } from '../../shared/pipes/dimension.pipe';
import { WeightPipe } from '../../shared/pipes/weight.pipe';
import { ShipmentTrackingComponent } from '../shipment-tracking/shipment-tracking.component';
import { DocumentLinkComponent } from '../../shared/document-link/document-link.component';
import { PriceBreakdownComponent } from '../../shared/price-breakdown/price-breakdown.component';
import { ShipmentIndicatorComponent } from '../shipment-indicator/shipment-indicator.component';
import { QuoteCardComponent } from '../quote-card/quote-card.component';
import { AsyncPipe, DatePipe } from '@angular/common';
import { Document } from '../../../models/document';
import { PickupStatusEnum } from '../../../enum/pickup-status.enum';
import { PickupActionEnum } from '../../../enum/pickup-action.enum';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { CardDisplayComponent } from '../../shared/card-display/card-display.component';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { selectRouteParamDeep } from '../../../store/router/router.state';

@Component({
    selector: 'app-shipment-view',
    templateUrl: './shipment-view.component.html',
    styleUrls: [ './shipment-view.component.scss' ],
    imports: [ QuoteCardComponent, ShipmentIndicatorComponent, PriceBreakdownComponent, DocumentLinkComponent, ShipmentTrackingComponent,
        AsyncPipe, DatePipe, WeightPipe, DimensionPipe, MatCard, MatCardContent, MatProgressSpinner,
        CardDisplayComponent ]
})
export class ShipmentViewComponent implements OnInit {

    public status = ShipmentStatusEnum;

    constructor(private store: Store<AppState>, private shipmentService: ShipmentService) {
    }

    public loading$ = this.shipmentService.loading$;

    public shipment$: Observable<Shipment> = this.store.select(selectRouteParamDeep('id')).pipe(
        switchMap(id => this.shipmentService.observe(id)),
        filter(shipment => !!shipment)
    );

    public showPickupSection$: Observable<boolean> = this.shipment$.pipe(
        filter(shipment => !!shipment.pickup),
        map(shipment => !!shipment.pickup.reference || shipment.pickup.allowedActions.length > 0)
    );

    public pickupSectionTitle$: Observable<string> = this.shipment$.pipe(
        map(shipment => this.titleForPickupSection(shipment))
    );

    public pickupReference$: Observable<string> = this.shipment$.pipe(
        map(shipment => shipment.pickup ? shipment.pickup.reference : '')
    );

    public pickupDate$: Observable<string> = this.shipment$.pipe(
        map(shipment => shipment.pickup ? new DatePipe('en-US').transform(shipment.pickup.date, 'short') : '')
    );

    titleForPickupSection(shipment: Shipment): string {
        switch (shipment.pickup.status) {
            case PickupStatusEnum.SCHEDULED:
                if (shipment.statusCode === ShipmentStatusEnum.MANIFESTED) {
                    return $localize`Scheduled Pickup`;
                } else {
                    return $localize`Pickup`;
                }
            case PickupStatusEnum.CLOSED:
                return $localize`Shipment Closed`;
            case PickupStatusEnum.MANIFESTED:
                return $localize`Shipment On Manifest`;
            default:
                return $localize`Pickup`;
        }
    }

    showPickupDetail(shipment: Shipment): boolean {
        return shipment.pickup && !!shipment.pickup.reference;
    }

    showPickupBooking(shipment: Shipment): boolean {
        return shipment.pickup && shipment.pickup.status === PickupStatusEnum.SCHEDULED;
    }

    documentsForPackage(shipment: Shipment, id: string): Document[] {
        return shipment.documents.filter(d => d.packageId?.toString() === id);
    }

    documentsForShipment(shipment: Shipment): Document[] {
        return shipment.documents.filter(d => !d.packageId);
    }

    ngOnInit(): void {
    }

}
